const toTitle = (value) => {
  const text = String(value || "Shift").trim();
  return text ? text.charAt(0).toUpperCase() + text.slice(1) : "Shift";
};

export const shiftDisplayLabel = (shift) => {
  const type = toTitle(shift?.type);
  const start = shift?.start_time || "";
  const end = shift?.end_time || "";

  if (start || end) {
    return `${type} [${start} - ${end}]`;
  }

  return type;
};
